/* This centralized CSS should be used for any "Details" page, for consistency between such pages. */

/* Tabs at the bottom of the page should be visually separated from the "main" content. */
.tabContent {
    margin-top: 20px;
}

/* Wraps the entire "details" section and renders children vertically. */
.detailsContainer {
    display: flex;
    flex-direction: column;
}

/* Renders multiple evenly-spaced columns. Immediate descendants should be of the `detailsGridColumn` class. */
.detailsGridSection {
    display: flex;
    justify-content: space-between;
    max-width: 85%;
}

.detailsGridColumn {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

/* This class should wrap any field label + field value pair in the "details" section. Standardizes spacing between children of the details container. */
.labelAndValueContainer {
    margin-bottom: 20px;
}
